 @if (userMembers.length != 0 ) {
<table mat-table [dataSource]="userMembers" class="mat-elevation-z1 personal-files-table width-100per individual-user-member-table" style="border-radius:0px 0px 12px 12px; overflow: hidden;"
[ngClass]="{'min-w-[700px]': !isFromDiscovery, 'min-w-full': isFromDiscovery}">
  <!-- Checkbox Column -->
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef style="width: 5%; text-align: center; color: #707070; background: #FFFFFF; border-right: 1px solid #e0e0e0;padding: 0px !important;"> 
      <mat-checkbox
        aria-label="Select all items"
        (change)="selectAll($event)"
        [(ngModel)]="allSelected"
      ></mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let item" style="width: 5%; text-align: center; border-right: 1px solid #e0e0e0; padding: 0px !important;"
    [ngStyle]="{'background': item.status === 'not in use' ? '#F8F8F8' : 'white'}">
        <mat-checkbox
          class="individual-user-member-checkbox"
          (change)="selectOne($event, item)"
          [(ngModel)]="item.checked"
          (click)="$event.stopPropagation()"
          [disabled]="item.status === 'not in use'"
        ></mat-checkbox>
    </td>
  </ng-container>

      <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef style="width: 25%; background: #FFFFFF; border-right: 1px solid #e0e0e0; text-align: left;color: #707070;font-family: 'Open Sans'; font-size: 14px; font-weight: 400;">Name</th>
      <td mat-cell *matCellDef="let item" style="width: 25%; border-right: 1px solid #e0e0e0; text-align: left; font-family: 'Open Sans'; font-size: 14px; font-weight: 500; line-height: normal; letter-spacing: 0.06px;" 
      [ngStyle]="{'background': item.status === 'not in use' ? '#F8F8F8' : item?.itemEditInputField ? '#fff2cd' : 'white' , 'color': item.status === 'not in use' ? '#707070' : '#010B18'}">
      <mat-form-field
        style="width: 100%"
        appearance="fill"
        class="individual-user-member-name-input"
        [ngClass]="{'individual-user-member-name-input-edit': item?.itemEditInputField}"
      >
        <input
          class="relative z-50 h-full w-full text-truncate"
          #nameInput
          matInput
          type="text"
          name="name"
          [matTooltip]="item?.name"
          [(ngModel)]="item.name"
          (change)="onNameChange(item)"
          (focus)="onNameInput(item);nameInput.select();"
          (blur)="onNameBlur(item)"
          style="width: 100%"
          [disabled]="item.status === 'not in use'"
          autocomplete="off"
        />
      </mat-form-field>
              <!-- <span class="text-truncate" style="max-width: 220px; display: inline-block; vertical-align: middle;">{{ item?.name ? item?.name : ('' | truncateStrPipe : 55) }}</span> -->
    </td>
  </ng-container>

  <!-- Status/Action Column -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef style="width: 17%; background: #FFFFFF; border-right: 1px solid #e0e0e0; text-align: center;color: #707070;font-family: 'Open Sans'; font-size: 14px; font-weight: 400;">Status</th>
    <td mat-cell *matCellDef="let item" style="width: 17%; border-right: 1px solid #e0e0e0; text-align: start;padding: 0px !important;"
    class="hover:bg-[#EBF0FA]"
    >
          <mat-select [(ngModel)]="item.status" (ngModelChange)="onStatusChange(item)" 
          (openedChange)="item.isStatusMenuOpen = $event"
          style="min-width: 90px;
          height: 52px;
          font-family: 'Open Sans';
          font-size: 12px;
          font-weight: 600;
          line-height: normal;
          letter-spacing: 0.06px;" class="status-dropdown-select" 
          panelClass="status-dropdown individual-user-member-dropdown mt-[4px] min-w-[200px] ml-[-38px]"
          *ngIf="item.user_account_status !== null"
          [ngClass]="{'border border-[#25508E] bg-[#EBF0FA]': item.isStatusMenuOpen}"
          >
            <mat-option value="in use"><span class="text-[#25508E] text-sm font-semibold font-open-sans">In Use</span></mat-option>
            <mat-option value="not in use"><span class="text-[#EB5757] text-sm font-normal font-open-sans">Not In Use</span></mat-option>
          </mat-select>
          <span class="material-icons" style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); pointer-events: none; color: #25508E;">keyboard_arrow_down</span>
    </td>
  </ng-container>

  <!-- Template Column -->
  <ng-container matColumnDef="template">
    <th mat-header-cell *matHeaderCellDef style="width: 23%; background: #FFFFFF; border-right: 1px solid #e0e0e0; text-align: center;color: #707070;font-family: 'Open Sans'; font-size: 14px; font-weight: 400;">Template</th>
          <td mat-cell *matCellDef="let item" style="width: 23%; position: relative;border-right: 1px solid #e0e0e0;"
      [ngStyle]="{'background': (item.status === 'not in use' || item.status === 'in use') ? '#F8F8F8' : 'white' }">
      <div class="template-dropdown-wrapper">
                  <div
            class="selected-template flex items-center justify-between min-h-[40px]"
            [class.cursor-pointer]="getStatusActionHeader() === 'Action'"
            [class.cursor-default]="getStatusActionHeader() === 'Status'"
            [class.opacity-50]="getStatusActionHeader() === 'Status'"
            (click)="getStatusActionHeader() === 'Action' ? openTemplateDropdown(item) : null"
          >
            <ng-container *ngIf="item.vaultUserForm?.form_name; else templatePlaceholder">
              <div class="font-family-open-sans text-[12px] overflow-hidden text-ellipsis whitespace-nowrap max-w-[100px]" matTooltip="{{ getTemplateType(item) || item.vaultUserForm?.form_name }}">{{ getTemplateType(item) || item.vaultUserForm?.form_name }}</div>
          </ng-container>
                      <ng-template #templatePlaceholder>
              <span class="text-sm" [class.text-[#b0b0b0]]="getStatusActionHeader() === 'Status'">
                {{ getStatusActionHeader() === 'Action' ? 'Select Template' : 'Template' }}
              </span>
            </ng-template>
                      <!-- <span class="material-icons ml-2" [class.text-[#25508E]]="getStatusActionHeader() === 'Action'" [class.text-[#b0b0b0]]="getStatusActionHeader() === 'Status'">keyboard_arrow_down</span> -->
        </div>
                  <div
            class="template-dropdown-list absolute left-1/2 -translate-x-1/2 z-50 bg-white shadow-lg rounded-xl w-[320px] mt-2 border border-[#e0e0e0]"
            *ngIf="item.showTemplateDropdown && item.status !== 'not in use'"
          >
          <div class="flex items-center px-4 py-2 border-b border-[#eee] bg-[#fafbfc] rounded-t-xl">
            <img src="assets/images/blue-search-icon.svg" width="18" height="18" class="mr-2" />
            <input
              type="text"
              [(ngModel)]="item.templateSearchText"
              (input)="filterTemplates(item)"
              placeholder="Search templates"
              class="outline-none w-full text-sm px-1 py-1 bg-transparent border-0"
              style="box-shadow: none"
            />
            <span (click)="item.templateSearchText = ''; filterTemplates(item)" class="material-icons ml-1 text-[#898F9E] cursor-pointer"
              >clear</span
            >
          </div>
          <div class="max-h-[320px] overflow-y-auto py-2">
            <ng-container *ngIf="templates && templates.length > 0; else showTemplateLoader">
              <p class="text-[#b0b0b0] text-center py-2" *ngIf="item.filteredTemplates && item.filteredTemplates.length === 0">
                No results found
              </p>
              <ul *ngIf="item.filteredTemplates && item.filteredTemplates.length > 0">
                <li
                  *ngFor="let template of item.filteredTemplates"
                  class="flex items-center px-4 py-3 hover:bg-[#f5f5f5] cursor-pointer rounded-lg transition"
                  (click)="item.template = template; item.showTemplateDropdown = false"
                >
                  <div class="flex-shrink-0 w-10 h-10 rounded bg-[#f3f4f6] flex items-center justify-center mr-3">
                    <img *ngIf="template.image" [src]="template.image" width="36" height="36" class="object-cover rounded" />
                    <span *ngIf="!template.image" class="material-icons text-[#b0b0b0] text-2xl">insert_drive_file</span>
                  </div>
                  <div class="flex flex-col items-start">
                    <span class="font-semibold text-[#18191C] text-base leading-5" matTooltip="{{ template.type }}">{{ item.vaultUserForm?.form_name | truncateStrPipe : 18 }}</span>
                    <span class="text-xs text-[#898F9E] mt-1">{{ template.type_template }}</span>
                  </div>
                </li>
              </ul>
            </ng-container>
            <ng-template #showTemplateLoader>
              <div class="p-3 text-center text-[#b0b0b0]">No Templates Found</div>
            </ng-template>
          </div>
        </div>
      </div>
    </td>
  </ng-container>

            <!-- Vault Column -->
    <ng-container matColumnDef="vault">
      <th mat-header-cell *matHeaderCellDef style="width: 15%; background: #FFFFFF; border-right: 1px solid #e0e0e0; text-align: center;color: #707070;font-family: 'Open Sans'; font-size: 14px; font-weight: 400;">Vault</th>
      <td mat-cell *matCellDef="let item; let i = index" style="width: 15%; text-align: center; border-right: 1px solid #e0e0e0; padding: 0px !important;"
        [ngStyle]="{'background': item.status === 'not in use' ? '#F8F8F8' : item.isVaultMenuOpen ? '#EBF0FA' : 'white'}"
        [style.padding]="item.activeVault && !(item.selectedVault || item.vaultUserForm?.vaultUserFolder?.vault) ? '0px !important' : '0px !important'"
        [ngClass]="{'hover:bg-[#EBF0FA]': item.status !== 'not in use'}">
          <button
          [matMenuTriggerFor]="vaultMenu"
          (menuOpened)="item.isVaultMenuOpen = true"
          (menuClosed)="item.isVaultMenuOpen = false"
          [matTooltip]="item.selectedVault?.name || item.vaultUserForm?.vaultUserFolder?.vault?.name"
          class="text-truncate h-[52px] px-3"
          style="width: 100%; display: flex; align-items: center; justify-content: space-between; border-radius: 0px; font-family: 'Open Sans'; font-size: 12px; font-weight: 600; line-height: normal; letter-spacing: 0.06px; border: none;"
          [disabled]="item.status === 'not in use'"
          [ngClass]="{'border border-[#25508E] bg-[#EBF0FA] w-[calc(100%-2px)]': item.isVaultMenuOpen}"
          [ngStyle]="{'background': 'transparent', 
          'border': item.isVaultMenuOpen ? '1px solid #25508E' : 'none', 
          }"
          (click)="$event.stopPropagation();"
        > 
          <span [ngClass]="{'text-[#18191C]': item.status !== 'not in use', 'text-[#939393]': item.status === 'not in use'}" class="text-[12px] font-semibold font-open-sans leading-normal " style="width: calc(100% - 30px); text-align: left;">
            {{ item.selectedVault?.name ? (item.selectedVault.name | truncateStrPipe : 16) : (item.vaultUserForm?.vaultUserFolder?.vault?.name ? (item.vaultUserForm?.vaultUserFolder?.vault?.name | truncateStrPipe : 16) : 'Vault') }}
          </span>
          <span class="material-icons ml-2" [class]="(item.status === 'not in use' ? 'text-[#C1C2C5]' : 'text-[#25508E]')">keyboard_arrow_down</span>
        </button>
      <mat-menu #vaultMenu="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel individual-user-member-vault-menu min-w-[308px] w-[308px] mr-[-80px] mt-[4px]">
        <div class="app__centered-item w-full h-[48px]" style="padding: 8px 24px 8px 24px; border-bottom: 1px solid #b1acb066; width: 306px; min-width: 306px; max-width: 306px;">
          <span class="mt-[-2px] text-[#5475C0]"><img src="assets/images/blue-search-icon.svg" width="16px" height="16px" /></span>
          <input
            class="h-full w-full ml-2 border-none outline-none text-[13px]"
            type="text"
            [(ngModel)]="item.vaultSearchText"
            [placeholder]="'Search Vaults'"
            (click)="$event.stopPropagation()"
          />
          <span *ngIf="item.vaultSearchText" (click)="item.vaultSearchText = ''; $event.stopPropagation()" class="material-icons relative bg-white text-[#898F9E] text-[22px] leading-7 hover:cursor-pointer">clear</span>
        </div>
        <div style="height: 240px; max-height: 240px; overflow-y: auto; width: 306px; min-width: 306px; max-width: 306px;">
          <!-- @if(item.ai_suggested_item){
          <button mat-menu-item class="individual-user-member-popup-menu-item h-16" style="width: 292px; margin-bottom: 4px; min-width: 292px; max-width: 292px;" (click)="item.selectedVault = item.ai_suggested_item; updateFormGroupIdSingle(item); vaultMenu.closed.emit(); $event.stopPropagation()">
            <div class="flex" style="margin-top: 10px; align-items: center;">
              <img src="assets/images/ai_suggestion.svg" class="w-10 p-1 h-10 bg-[#EBF0FA] rounded" alt="icon" />
              <div class="ml-1" style="margin-top: 12px; display: flex; flex-direction: column">
                <p class="text-[12px] font-semibold text-[#18191c]" [matTooltip]="item.ai_suggested_item?.name" style="margin-bottom: 10px">
                  {{ item.ai_suggested_item?.name | truncateStrPipe : 15 }}
                </p>
                <span class="text-[11px] text-[#7B61FF] font-medium">Kinnect Ai Suggestion</span>
              </div>
              @if(item.ai_suggested_item?.id == -1){
              <span
                class="bg-[#D1F6E1] leading-6 mx-1 w-9 h-6 text-[#1AA140] font-bold text-[10px] rounded"
                style="text-align: center; margin-top: 8px"
              >
                New
              </span>
              }
            </div>
          </button>
          } -->
          @for (vault of vault_list | filterList : item.vaultSearchText; track vault) { @if(item.ai_suggested_item?.id !== vault?.id){
          <button mat-menu-item class="individual-user-member-popup-menu-item h-16" style="width: 292px; min-width: 292px; max-width: 292px;" (click)="item.selectedVault = vault; updateFormGroupIdSingle(item,vault); vaultMenu.closed.emit(); $event.stopPropagation()">
            <div class="flex items-center">
              <div class="flex justify-center items-center h-[40px] w-[40px] bg-[#EBF0FA] rounded-[4px]">
                @if (!vault?.type) {
                  <img class="h-[32px] w-[32px]" src="assets/images/vault/personal.svg" />
                  } @if (vault?.type === 'personal') {
                  <img class="h-[32px] w-[32px]" src="assets/images/vault/personal.svg" />
                  } @if (vault?.type === 'shared') {
                  <img class="h-[32px] w-[32px]" src="assets/images/vault/shared.svg" />
                  } @if (vault?.type === 'holding' || vault?.type === 'trust' || vault?.type === 'entity') {
                  <img class="h-[32px] w-[32px]" src="assets/images/vault/entity.svg" />
                  }
              </div>
              <div class="ml-2 gap-[2px]" style="display: flex; flex-direction: column">
                <div class="text-[12px] font-semibold font-open-sans text-[#18191c] leading-normal">{{ vault.name | truncateStrPipe : 28 }}</div>
                <div class="capitalize text-[#707070] text-[10px] font-medium font-open-sans leading-normal">{{ vault.type }}</div>
              </div>
            </div>
          </button>
          } }
          @if (vault_list?.length >0 && (vault_list | filterList : item.vaultSearchText).length == 0) {
          <div class="text-center text-[#898F9E] text-[14px]">No vaults found</div>
          }
        </div>
        <button mat-menu-item disableRipple class="cy-add-new-vault-btn-menu p-0 h-[42px] bg-[#EBF0FA]" style="justify-content: center; width: 306px; min-width: 306px; max-width: 306px;" (click)="addNewVault(item)">
          <p class="menuitem-text text-[#25508E] text-[16px] font-bold flex items-center justify-center">
            <span style="font-size: 22px;">+</span>
            Create New
          </p>
        </button>
      </mat-menu>
    </td>
  </ng-container>

  <!-- View Column -->
  <ng-container matColumnDef="view">
    <th mat-header-cell *matHeaderCellDef style="width: 7%; background: #FFFFFF; text-align: center;color: #707070;font-family: 'Open Sans'; font-size: 14px; font-weight: 400;">View</th>
    <td mat-cell *matCellDef="let item" style="width: 7%; text-align: center;"[ngStyle]="{'background': item.status === 'not in use' ? '#F8F8F8' : 'white'}">
              <button mat-icon-button (click)="openForm(item)" aria-label="View details" class="bg-[#EBF0FA] w-[32px] h-[32px]" *ngIf="item.status !== 'not in use'">
      <img src="assets/images/inbox/view.svg" alt="view" style="width: 20px; height: 20px; margin-top: -15px; margin-left: -5px;">
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="['select', 'name', 'status', 'template', 'vault', 'view']" style="background: #f9f9f9;height: 45px !important;"></tr>
  <tr mat-row *matRowDef="let row; let i = index; columns: ['select', 'name', 'status', 'template', 'vault', 'view'];" [ngClass]="{'excluded-row': row.status === 'not_in_use'}"></tr>

  <!-- Empty State -->
  <tr *ngIf="userMembers.length === 0">
    <td colspan="6">
      <div class="flex-center zero-state">
        <img src="assets/images/no-filse-ingroup.svg" style="height: 90px" />
        <p class="no-file-text">Nothing to see here</p>
      </div>
    </td>
  </tr>
</table>

  <div *ngFor="let row of userMembers; let i = index"
      class="loader-row absolute w-full z-[999]"
      [style.top.px]="(i * 52) + (117 + i)"
      [ngClass]="{'hidden': !row.loading}"
  >
  <mat-progress-spinner mode="indeterminate" diameter="18" class="mr-2 text-[#25508E]"></mat-progress-spinner>
  <span>One moment while we save this</span>
  </div>

  <div *ngFor="let row of userMembers; let i = index"
      class="loader-row absolute w-full z-[999]"
      [style.top.px]="(i * 52) + (117 + i)"
      [ngClass]="{'hidden': !row.saveLoading}"
  >
  <mat-icon class="text-[#1AA240]">check</mat-icon>
  <span>Saved</span>
  </div>

} @else {
<div class="flex-center zero-state">
  <img src="assets/images/no-filse-ingroup.svg" style="height: 90px" />
  <p class="no-file-text">Nothing to see here</p>
</div>
}